<template lang="pug">

    div
        h5 Bemerkungen zum Unternehmen
        p.small(v-if='note.length') {{ note }}
        p.ui.info.message(v-else) Keine Bemerkung vorhanden


</template>

<script>
    import * as R from 'ramda'

    export default {

        computed: {

            note() {
                return R.defaultTo('', this.companyModel.notice)
            }

        },

        props: {

            companyModel: {
                type: Object,
                required: true
            }

        }

    }

</script>
